const it = {
  "nav.chefs": "I Nostri Chef",
  "nav.experiences": "Esperienze",
  "nav.privateDining": "Cena Privata",
  "nav.journal": "Journal",
  "nav.howItWorks": "Come Funziona",
  "nav.events": "Eventi",
  "nav.corporate": "Aziende",
  "nav.bespoke": "Su Misura",
  "nav.giftCards": "Carte Regalo",
  "nav.becomeChef": "Diventa Chef",
  "nav.about": "Chi Siamo",
  "nav.contact": "Contatti",
  "nav.faq": "FAQ",
  "nav.login": "Accedi",
  "nav.logout": "Esci",
  "nav.account": "Il Mio Account",
  "nav.findChef": "Trova il Mio Chef",
  "nav.more": "Altro",
  "hero.line1": "Cucina d'Eccezione.",
  "hero.line2": "A Casa Tua.",
  "hero.sub": "Chef privati verificati creano esperienze gastronomiche a cinque stelle nell'intimità della tua sala da pranzo. A Parigi e oltre.",
  "hero.badge": "Concierge di Chef Privati",
  "search.location": "Città",
  "search.date": "Data",
  "search.guests": "Ospiti",
  "search.cuisine": "Cucina",
  "search.experience": "Esperienza",
  "search.any": "Tutte",
  "search.cta": "Trova il Mio Chef",
  "home.featuredEyebrow": "La Selezione della Maison",
  "home.featuredTitle": "Chef di Distinzione",
  "home.viewAll": "Scopri tutti gli chef",
  "home.expEyebrow": "Esperienze Signature",
  "home.expTitle": "Sei Modi di Cenare in Modo Straordinario",
  "home.trustEyebrow": "La Nostra Promessa",
  "home.trustTitle": "Ogni Chef, Selezionato con Cura",
  "home.trustIntro": "Dietro ogni badge «Chef Verificato» c'è una rigorosa verifica professionale. Ammettiamo solo chef che completano la nostra revisione — la tua tavola è sempre in mani esperte.",
  "trust.i1": "Verifica dell'identità (KYC)",
  "trust.i2": "Esame dell'esperienza professionale",
  "trust.i3": "Revisione di profilo e portfolio",
  "trust.i4": "Revisione delle pratiche di cucina",
  "trust.i5": "Standard del portfolio piatti",
  "trust.i6": "Documentazione igienica applicabile",
  "trust.i7": "Conformità bancaria",
  "home.manifestoEyebrow": "Il Manifesto",
  "man.c1t": "La Tavola È Sacra",
  "man.c1b": "Una cena a casa non è una consegna. È teatro, ospitalità e mestiere — composta per chi ami, nel luogo che ami di più.",
  "man.c2t": "Il Mestiere Prima della Comodità",
  "man.c2b": "I nostri chef fanno la spesa ai mercati del mattino, cucinano nella tua cucina e servono portata dopo portata. Niente di riscaldato, niente di ordinario.",
  "man.c3t": "Fiducia Verificata",
  "man.c3b": "Ogni chef di Chef à Domicile supera una verifica professionale prima di servire un solo piatto. L'eccellenza è il requisito d'ingresso.",
  "home.marquee": "Chef Privato Parigi — Chef à Domicile — Cena Privata di Lusso — Menu Su Misura — Ospitalità Cinque Stelle —",
  "home.ctaTitle": "La tua tavola merita uno chef.",
  "home.ctaBtn": "Prenota un'Esperienza",
  "home.journalEyebrow": "Il Journal",
  "home.journalTitle": "Storie dalla Tavola",
  "common.verified": "Chef Verificato",
  "common.perGuest": "a ospite",
  "common.from": "Da",
  "common.viewProfile": "Vedi Profilo",
  "common.book": "Prenota",
  "common.loading": "Caricamento…",
  "common.error": "Qualcosa è andato storto.",
  "common.retry": "Riprova",
  "common.empty": "Ancora niente qui.",
  "common.readMore": "Leggi di più",
  "common.back": "Indietro",
  "common.send": "Invia",
  "common.sending": "Invio…",
  "common.yearsExp": "{n} anni di esperienza",
  "common.reviews": "recensioni",
  "common.languages": "Lingue",
  "common.all": "Tutte",
  "common.cancel": "Annulla",
  "common.save": "Salva",
  "common.delete": "Elimina",
  "common.add": "Aggiungi",
  "common.optional": "opzionale",
  "common.next": "Continua",
  "common.confirm": "Conferma",
  "common.total": "Totale",
  "common.guests": "ospiti",
  "chefs.title": "Il Marketplace degli Chef Verificati",
  "chefs.sub": "Chef privati d'eccezione, verificati dal nostro team, pronti a cucinare a casa tua.",
  "chefs.filters": "Filtri",
  "chefs.clear": "Cancella filtri",
  "chefs.cuisine": "Cucina",
  "chefs.city": "Città",
  "chefs.minRating": "Valutazione minima",
  "chefs.maxPrice": "Prezzo max / ospite",
  "chefs.language": "Lingua dello chef",
  "chefs.noResults": "Nessuno chef corrisponde a questi criteri. Amplia la ricerca.",
  "chefs.count": "{n} chef verificati",
  "chef.about": "Sullo Chef",
  "chef.signature": "Piatti Signature",
  "chef.reviews": "Recensioni degli Ospiti",
  "chef.bookThis": "Prenota questo Chef",
  "chef.qualification": "Qualifica",
  "chef.allergens": "Allergeni",
  "chef.dietary": "Diete",
  "chef.prep": "{n} min di preparazione",
  "exp.title": "Esperienze Signature",
  "exp.sub": "Sei modi curati per portare l'alta cucina a casa — da una cena intima alla carta a un evento gastronomico interamente su misura.",
  "booking.title": "Prenota la Tua Esperienza",
  "booking.step1": "Menu",
  "booking.step2": "Dettagli",
  "booking.step3": "Conferma e Paga",
  "booking.selectDish": "Scegli un piatto signature",
  "booking.date": "Data",
  "booking.time": "Ora",
  "booking.address": "Indirizzo",
  "booking.city": "Città",
  "booking.occasion": "Occasione",
  "booking.requests": "Richieste speciali",
  "booking.create": "Rivedi la mia prenotazione",
  "booking.promo": "Codice promo o carta regalo",
  "booking.promoApply": "Applica",
  "booking.promoApplied": "Codice applicato",
  "booking.chef": "Il Tuo Chef",
  "booking.pricePerGuest": "Prezzo a ospite",
  "booking.pay": "Procedi al Pagamento Sicuro",
  "booking.payNote": "Verrai reindirizzato a un pagamento sicuro Stripe. L'importo finale è calcolato dal nostro servizio.",
  "booking.loginFirst": "Accedi per completare la prenotazione.",
  "booking.stripeOff": "Il pagamento online è temporaneamente non disponibile. La tua prenotazione è salvata — il nostro concierge ti contatterà per finalizzare il pagamento.",
  "booking.discount": "Sconto",
  "pay.checking": "Conferma del pagamento…",
  "pay.success": "Pagamento confermato. Il tuo chef è stato avvisato — ci vediamo a tavola.",
  "pay.failed": "Il pagamento non è stato completato.",
  "pay.pending": "Il pagamento è in elaborazione. Questa pagina si aggiornerà automaticamente.",
  "pay.backAccount": "Vai alle mie prenotazioni",
  "auth.loginTitle": "Bentornato",
  "auth.registerTitle": "Crea il Tuo Account",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.name": "Nome completo",
  "auth.loginBtn": "Accedi",
  "auth.registerBtn": "Crea Account",
  "auth.toRegister": "Nuovo su Chef à Domicile? Crea un account",
  "auth.toLogin": "Già membro? Accedi",
  "account.title": "Il Mio Account",
  "account.bookings": "Prenotazioni",
  "account.favorites": "Preferiti",
  "account.giftcards": "Carte Regalo",
  "account.dietary": "Profilo Alimentare",
  "account.addresses": "Indirizzi",
  "account.noBookings": "Nessuna prenotazione. La tua prossima cena eccezionale ti aspetta.",
  "account.noFavorites": "Nessuno chef preferito.",
  "account.status": "Stato",
  "account.cancelBooking": "Annulla prenotazione",
  "account.review": "Lascia una recensione",
  "account.reviewComment": "Il tuo commento",
  "account.messages": "Messaggi",
  "account.writeMsg": "Scrivi un messaggio al tuo chef…",
  "account.allergies": "Allergie",
  "account.diets": "Diete e preferenze",
  "account.saveProfile": "Salva profilo",
  "account.addAddress": "Aggiungi indirizzo",
  "account.label": "Etichetta (Casa, Ufficio…)",
  "account.noGiftcards": "Nessun ordine di carte regalo.",
  "account.commaHint": "Separa con virgole",
  "gift.title": "Il Regalo di una Tavola Indimenticabile",
  "gift.sub": "Regala un'esperienza di chef privato. Il destinatario riceve un'elegante carta regalo, valida su ogni prenotazione.",
  "gift.amount": "Importo (25 € – 1000 €)",
  "gift.recipientName": "Nome del destinatario",
  "gift.recipientEmail": "Email del destinatario",
  "gift.message": "Messaggio personale",
  "gift.buy": "Acquista Carta Regalo",
  "gift.note": "Il codice viene generato e inviato via email solo dopo la conferma del pagamento.",
  "becomeChef.title": "Cucina per le Tavole Più Belle",
  "becomeChef.sub": "Unisciti a Chef à Domicile come chef privato. I tuoi menu, i tuoi prezzi, la tua agenda — noi ti portiamo clienti esigenti.",
  "becomeChef.cta": "Candidati come Chef",
  "becomeChef.bio": "La tua storia e il tuo percorso culinario",
  "becomeChef.years": "Anni di esperienza",
  "becomeChef.qualification": "Qualifica / formazione",
  "becomeChef.city": "Città",
  "becomeChef.cuisines": "Le tue cucine",
  "becomeChef.success": "Candidatura ricevuta. Il tuo profilo entra nel nostro processo di verifica professionale — il nostro team ti contatterà.",
  "becomeChef.s1t": "Candidati",
  "becomeChef.s1b": "Raccontaci la tua esperienza, la formazione e la tua cucina signature.",
  "becomeChef.s2t": "Fatti Verificare",
  "becomeChef.s2b": "Identità, esperienza, pratiche di cucina e portfolio vengono esaminati professionalmente.",
  "becomeChef.s3t": "Cucina e Guadagna",
  "becomeChef.s3b": "Ricevi prenotazioni da clienti raffinati e vieni pagato in sicurezza.",
  "inquiry.contactTitle": "Contatta la Maison",
  "inquiry.contactSub": "Una domanda, un progetto, una richiesta speciale — il nostro concierge risponde entro 24 ore.",
  "inquiry.corporateTitle": "Esperienze Aziendali",
  "inquiry.corporateSub": "Cene executive, ospitalità clienti, celebrazioni di team — una cucina all'altezza della tua azienda.",
  "inquiry.corporateCta": "Richiedi un'Esperienza Aziendale",
  "inquiry.eventsTitle": "Eventi di Ogni Scala",
  "inquiry.eventsSub": "Compleanni, matrimoni, ricevimenti — una produzione culinaria completa, dal menu al servizio.",
  "inquiry.eventsCta": "Organizza il Mio Evento",
  "inquiry.bespokeTitle": "Menu Interamente Su Misura",
  "inquiry.bespokeSub": "Un menu unico, disegnato con il tuo chef intorno alla tua storia, ai tuoi prodotti, alla tua occasione.",
  "inquiry.bespokeCta": "Avvia un Progetto Su Misura",
  "inquiry.eventType": "Tipo di evento",
  "inquiry.budget": "Budget",
  "inquiry.location": "Luogo",
  "inquiry.company": "Azienda",
  "inquiry.phone": "Telefono",
  "inquiry.date": "Data desiderata",
  "inquiry.guests": "Ospiti",
  "inquiry.message": "Il tuo messaggio",
  "inquiry.success": "Grazie. Il nostro team concierge ti ricontatterà a breve.",
  "how.title": "Come Funziona",
  "how.sub": "Dal primo clic all'ultima portata — senza sforzo, in quattro movimenti.",
  "how.s1t": "01 — Componi",
  "how.s1b": "Scegli città, data, ospiti e cucina. Sfoglia gli chef verificati e i loro piatti signature.",
  "how.s2t": "02 — Prenota",
  "how.s2b": "Prenota in pochi minuti. Il prezzo è calcolato con trasparenza a ospite — senza costi nascosti.",
  "how.s3t": "03 — Accogli il Tuo Chef",
  "how.s3b": "Il tuo chef arriva con prodotti freschi, cucina nella tua cucina e serve portata dopo portata.",
  "how.s4t": "04 — Goditi la Serata",
  "how.s4b": "Il tuo chef lascia la cucina impeccabile. A te restano i ricordi — e i complimenti.",
  "about.title": "La Maison",
  "about.p1": "Chef à Domicile nasce da una convinzione semplice: il ristorante più memorabile del mondo è casa tua. Colleghiamo ospiti esigenti a chef privati verificati che trasformano una sala da pranzo in una tavola a cinque stelle.",
  "about.p2": "Da Parigi in poi, il nostro marketplace di livello concierge seleziona chef in 28 cucine del mondo — ognuno verificato professionalmente per identità, esperienza, pratiche di cucina e portfolio.",
  "about.p3": "Non siamo consegna di cibo. Siamo ospitalità — l'arte della tavola, portata a casa.",
  "privateDining.title": "La Cena Privata, Perfezionata",
  "privateDining.sub": "Cene intime da 2 a 20 ospiti, orchestrate da uno chef privato verificato.",
  "privateDining.p1": "Una serata con Chef à Domicile inizia molto prima della prima portata. Il tuo chef disegna il menu con te, seleziona i migliori prodotti del mattino e arriva pronto a trasformare la tua cucina nel pass di un grande ristorante.",
  "privateDining.p2": "Le portate si susseguono alla tua tavola — mentre tu resti con i tuoi ospiti. A fine serata, la cucina è lasciata impeccabile.",
  "privateDining.cta": "Trova uno Chef per la Mia Cena",
  "faq.title": "Domande Frequenti",
  "faq.q1": "Come vengono verificati gli chef?",
  "faq.a1": "Ogni chef supera una verifica professionale: identità (KYC), esperienza professionale, revisione del profilo, pratiche di cucina, portfolio piatti, documentazione igienica applicabile e conformità bancaria. Solo gli chef verificati appaiono sul marketplace.",
  "faq.q2": "Cosa include il prezzo a ospite?",
  "faq.a2": "La spesa dello chef, la preparazione, la cucina, il servizio al tavolo del menu e la pulizia della cucina. Il totale è calcolato con trasparenza dal nostro servizio alla prenotazione.",
  "faq.q3": "I menu si adattano ad allergie o diete?",
  "faq.a3": "Sì. Salva allergie e preferenze nel tuo profilo alimentare e aggiungi richieste speciali a ogni prenotazione — il tuo chef adatta il menu.",
  "faq.q4": "Come funziona il pagamento?",
  "faq.a4": "I pagamenti sono elaborati in sicurezza da Stripe. Vieni addebitato solo alla conferma della prenotazione; carte regalo e codici promo si applicano prima del checkout.",
  "faq.q5": "Posso annullare una prenotazione?",
  "faq.a5": "Sì, dal tuo account. Consulta la nostra politica di cancellazione per le condizioni secondo il preavviso.",
  "journal.title": "Il Journal",
  "journal.sub": "Gastronomia, ospitalità e arte della tavola — da Chef à Domicile.",
  "journal.empty": "Nuove storie sono in scrittura. Torna presto.",
  "journal.related": "Storie Correlate",
  "legal.termsTitle": "Termini di Servizio",
  "legal.privacyTitle": "Informativa sulla Privacy",
  "legal.cancelTitle": "Politica di Cancellazione",
  "legal.terms1": "Chef à Domicile gestisce un marketplace che collega clienti a chef privati indipendenti e verificati. Usando chef-adomicile.com accetti questi termini. La prenotazione forma un contratto tra cliente e chef, facilitato da Chef à Domicile.",
  "legal.terms2": "I prezzi sono mostrati a ospite; il totale finale è calcolato dal nostro servizio alla prenotazione. Il pagamento è elaborato dal nostro partner sicuro. Gli chef sono professionisti indipendenti responsabili del servizio culinario.",
  "legal.terms3": "Tutti i contenuti, i marchi e le immagini di questo sito appartengono a Chef à Domicile. L'uso improprio della piattaforma può comportare la sospensione dell'account.",
  "legal.privacy1": "Raccogliamo solo i dati necessari per il tuo account e le prenotazioni: identità, contatti, indirizzi, preferenze alimentari e cronologia. Non vendiamo mai i tuoi dati.",
  "legal.privacy2": "I dati di pagamento sono gestiti esclusivamente dal nostro partner; Chef à Domicile non memorizza mai numeri di carta.",
  "legal.privacy3": "Puoi richiedere accesso, correzione o cancellazione dei tuoi dati personali in ogni momento tramite la pagina contatti.",
  "legal.cancel1": "Puoi annullare una prenotazione dal tuo account. Le cancellazioni con preavviso sufficiente sono rimborsate secondo le condizioni comunicate alla prenotazione.",
  "legal.cancel2": "Le cancellazioni tardive possono comportare costi, poiché lo chef avrà acquistato i prodotti e riservato la data. I pagamenti con carta regalo vengono riaccreditati sulla carta.",
  "legal.cancel3": "Se uno chef deve annullare, il nostro concierge propone uno chef verificato equivalente o il rimborso completo, a tua scelta.",
  "footer.tag": "Cucina d'Eccezione. A Casa Tua.",
  "footer.explore": "Esplora",
  "footer.company": "La Maison",
  "footer.legal": "Legale",
  "footer.rights": "© 2026 Chef à Domicile — Tous droits réservés / All rights reserved",
  "seo.homeTitle": "Chef à Domicile — Chef Privato a Domicilio | Cena Privata di Lusso",
  "seo.homeDesc": "Prenota uno chef privato verificato per una cena eccezionale a casa. Cena privata di lusso a Parigi e oltre — menu su misura, eventi, esperienze aziendali.",
};
export default it;
